import { isEmpty } from 'lodash'

import { ECoinTypeAvailabilityMode, isFiatCurrency, mapNexCoinCodeToCommonCoinCode, requestGetPricesWindow, TCurrencyWithVolumeRecord, TPriceWindowApiDto } from 'nexchange-service/module/coins'

const filterCurrenciesByCoinType = (currencies, coinType, additionalFilterFn = () => true) => {
    switch (coinType) {
        case ECoinTypeAvailabilityMode.CRYPTO:
            return currencies.filter(c => c.isCrypto && additionalFilterFn())

        case ECoinTypeAvailabilityMode.FIAT:
            return currencies.filter(c => !c.isCrypto && additionalFilterFn())

        default:
            return currencies
    }
}

const validateAffectedSelectedCoin = (affectedCoinCode, affectedCoinList = []) => {
    if (isEmpty(affectedCoinList)) return null

    const validCoinData = affectedCoinList.find(coinData => coinData.code === affectedCoinCode)

    return !isEmpty(validCoinData) ? validCoinData : affectedCoinList[0]
}

const filterCurrenciesByValidPairs = ({ coinList, validPairList = [] }) =>
    coinList.filter(c => validPairList.includes(c.code))

const getCoinListOnCoinSelection = (currencies, validPairList, changedCoinType, affectedCoinType) =>
    /* ChangedCoin triggers change -> AffectedCoin, ChangedCoinList, AffectedCoinList */
    ({
        changedCoinList: filterCurrenciesByCoinType(currencies, changedCoinType),
        affectedCoinList: filterCurrenciesByValidPairs({
            coinList: filterCurrenciesByCoinType(currencies, affectedCoinType),
            validPairList,
        }),
    })


const getPrices = async (currencyWithVolumeRecord: TCurrencyWithVolumeRecord) => {
    const filterStableCoins = (commonCoinCode: string) => {
        const coin = mapNexCoinCodeToCommonCoinCode(commonCoinCode)
        return ['BUSD', 'USD', 'USDT', 'USDC', 'TUSD', 'DAI'].includes(coin)
    }
    const stableCurrencies = Object.keys(currencyWithVolumeRecord).filter(coin => filterStableCoins(coin)).map((coin) => {
        return {
            symbol: `${coin}USDT`,
            lastPrice: 1,
            priceChangePercent: '0.000',
        } as unknown as TPriceWindowApiDto
    });
    console.log("stableCurrencies", stableCurrencies)
    const currencies = Object.keys(currencyWithVolumeRecord).filter(coin => !filterStableCoins(coin) && !isFiatCurrency(coin)).map(x=> mapNexCoinCodeToCommonCoinCode(x));
    console.log("currencies", currencies)
    const currencySet = [...new Set(currencies)];
    const { data } = await requestGetPricesWindow({currencies: currencySet})
    if (data)
        return [...data, ...stableCurrencies]
    else return []

}

export { filterCurrenciesByCoinType, getCoinListOnCoinSelection, getPrices, validateAffectedSelectedCoin }
